<template>
   <el-dialog title="个性化热启动设置" v-model="dialogFormVisible" @close="close" :modal-append-to-body="false">
      <el-table border :data="[obj]">
         <el-table-column label="开屏广告">
            <template scope="{row}">
               <div style="padding: 10px; display: flex; align-items: center">
                  <el-input-number style="width: 130px" v-model="row.openScreenAd"></el-input-number>
                  <span style="margin-left: 10px">秒</span>
               </div>
            </template>
         </el-table-column>
         <el-table-column label="首页弹窗广告">
            <template scope="{row}">
               <div style="padding: 10px; display: flex; align-items: center">
                  <el-input-number style="width: 130px" v-model="row.homeScreenAd"></el-input-number>
                  <span style="margin-left: 10px">秒</span>
               </div>
            </template>
         </el-table-column>
         <el-table-column label="我的页面广告">
            <template scope="{row}">
               <div style="padding: 10px; display: flex; align-items: center">
                  <el-input-number style="width: 130px" v-model="row.myInformationFlowAd"></el-input-number>
                  <span style="margin-left: 10px">秒</span>
               </div>
            </template>
         </el-table-column>
      </el-table>
      <h3 style="margin: 30px 0">添加校区</h3>
      <el-form label-position="top" :model="adForm">
         <el-form-item label="校区">
            <div style="display: flex; align-items: center">
               <el-select v-model="adForm.unid" placeholder="请选择校区" filterable style="flex: 1; margin-right: 8px">
                  <el-option v-for="item in $props.CampusZoneList" :key="item.value" :label="item.label"
                     :value="item.value" />
               </el-select>
               <el-button type="primary" @click="handleAddCampusZones">添加</el-button>
            </div>
         </el-form-item>
         <el-form-item label="校区">
            <div class="card-wrap">
               <div v-for="item in obj.models" :key="item.unid" class="dialog-item">
                  <span>{{ item.name }}</span>
                  <el-button type="text" icon="circle-close" @click="handleDeleteCampus(item.unid)"></el-button>
               </div>
            </div>
            <div class="card-footer">共计{{ obj.models.length }}所学校</div>
         </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
         <el-button @click="dialogFormVisible = false">取 消</el-button>
         <el-button type="primary" @click="onSubimtForm">确 定</el-button>
      </div>
   </el-dialog>
</template>

<script>
export default {
   props: {
      CampusZoneList: {
         type: Array,
         default: () => [],
      },
   },
   data() {
      return {
         dialogFormVisible: false,
         obj: {
            openScreenAd: "",
            homeScreenAd: "",
            myInformationFlowAd: "",
            models: [],
         },
         adForm: {
            unid: "",
         },
      };
   },
   methods: {
      // 展示
      show(row) {
         if (row) {
            this.obj = JSON.parse(JSON.stringify(row));
         }
         this.dialogFormVisible = true;
      },
      // 添加
      handleAddCampusZones() {
         if (!this.adForm.unid) return;
         const find = this.obj.models.find(
            (item) => item.unid === this.adForm.unid
         );
         if (!find) {
            const f = this.$props.CampusZoneList.find(
               (item) => item.value === this.adForm.unid
            );
            this.obj.models.push({ unid: f.value, name: f.label });
         }
      },
      // 删除
      handleDeleteCampus(unid) {
         this.obj.models = this.obj.models.filter((item) => item.unid !== unid);
      },
      // 提交
      async onSubimtForm() {
         if (!this.obj.models.length) return this.$message.warning("请选择学校");
         const res = await this.$http({
            url: `${this.$util.domain}/adminapi/v2/ad/personalizedHotSpots/addOrEdit`,
            method: "post",
            body: JSON.stringify(this.obj),
         });
         if (res.data.error === 10000) {
            this.$message.success("操作成功");
            this.$emit("getData");
            this.dialogFormVisible = false;
         } else {
            this.$message.error(res.data.message || "操作失败");
         }
      },
      // 关闭
      close() {
         this.obj = {
            openScreenAd: "",
            homeScreenAd: "",
            myInformationFlowAd: "",
            models: [],
         };
         this.adForm.unid = "";
      },
   },
};
</script>

<style scoped>
.card-wrap {
   box-sizing: border-box;
   width: 100%;
   height: 200px;
   overflow: auto;
   padding: 10px;
   margin: 8px 0 4px;
   border: 1px solid #c0ccda;
   border-radius: 4px;
   font-size: 14px;
   line-height: 1.5;
}

.dialog-item {
   display: inline-block;
   margin: 0 4px 4px;
   padding: 4px;
   border: 1px solid #c0ccda;
   border-radius: 4px;
   font-size: 14px;
   line-height: 1.5;
}

.card-footer {
   text-align: right;
   font-size: 14px;
   line-height: 1.5;
}
</style>


// WEBPACK FOOTER //
// DiyCampusDialog.vue?2aa8e973